import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { SingleUploadComponent } from './components/single-upload/single-upload.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SingleFileUploadComponent } from './components/single-file-upload/single-file-upload.component';
import { DocsUploadComponent } from './components/docs-upload/docs-upload.component';
import { ReadCsvComponent } from './components/read-csv/read-csv.component';

@NgModule({
  declarations: [
    FileUploadComponent,
    SingleUploadComponent,
    SingleFileUploadComponent,
    DocsUploadComponent,
    ReadCsvComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule
  ],
  exports:[
    FileUploadComponent,
    SingleFileUploadComponent,
    DocsUploadComponent,
    ReadCsvComponent
  ]
})
export class UploadModule { }
